var _circle, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    encoding: "utf-8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#c10824"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "center-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "#ffffff",
    transform: "translate(125,125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L56,0 L171,125 L131,165 L56,90 L56,262 L0,262 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 262,
    x: 206
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.25a5b86ce66f9a69501e7402e3123d5f.svg";
export { ForwardRef as ReactComponent };